import * as React from "react";
import { singleton } from "logic/singleton";
const CarouselContext = React.createContext(void 0);
export default singleton("contexts.CarouselContext", () => CarouselContext);
